<template>
  <div class="poor-applications">
    <el-card class="box-card" shadow="hover">
      <template #header>
        <div class="card-header">
          <h2 class="title">贫困生申请审核</h2>
        </div>
      </template>

      <el-table
        :data="applications"
        style="width: 100%"
        v-loading="loading"
        :header-cell-style="{
          background: '#f5f7fa',
          color: '#606266',
          fontWeight: 600,
        }"
        :row-class-name="tableRowClassName"
      >
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="name" label="用户名" />
        <el-table-column prop="phone" label="手机号" />
        <el-table-column prop="email" label="邮箱" />
        <el-table-column label="操作" width="350" fixed="right">
          <template #default="scope">
            <el-button
              type="primary"
              link
              @click="downloadFile(scope.row)"
              class="action-button"
            >
              <el-icon><Download /></el-icon>
              下载材料
            </el-button>
            <el-button
              type="success"
              link
              @click="handleApprove(scope.row)"
              class="action-button"
            >
              <el-icon><Check /></el-icon>
              通过
            </el-button>
            <el-button
              type="danger"
              link
              @click="handleReject(scope.row)"
              class="action-button"
            >
              <el-icon><Close /></el-icon>
              拒绝
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { ref } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { Download, Check } from "@element-plus/icons-vue";
import { userApi } from "../api/order";

export default {
  name: "PoorApplications",
  components: {
    Download,
    Check,
  },
  setup() {
    const applications = ref([]);
    const loading = ref(false);

    // 获取贫困生申请列表
    const fetchApplications = async () => {
      loading.value = true;
      try {
        const response = await userApi.getPoorApplications();
        applications.value = response.data;
      } catch (error) {
        console.error("获取贫困生申请列表失败:", error);
        ElMessage.error("获取贫困生申请列表失败");
      } finally {
        loading.value = false;
      }
    };

    // 下载申请材料
    const downloadFile = async (user) => {
      try {
        const response = await userApi.downloadPoorFile(user.id);
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${user.id}_贫困生材料.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("下载贫困生材料失败:", error);
        ElMessage.error("下载贫困生材料失败");
      }
    };

    // 通过申请
    const handleApprove = (user) => {
      ElMessageBox.confirm(`确定要通过 ${user.name} 的贫困生申请吗？`, "确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info",
      })
        .then(async () => {
          try {
            await userApi.approvePoorApplication(user.id);
            ElMessage.success("已通过申请");
            fetchApplications(); // 重新加载列表
          } catch (error) {
            console.error("通过申请失败:", error);
            ElMessage.error("通过申请失败");
          }
        })
        .catch(() => {
          ElMessage.info("已取消操作");
        });
    };

    // 拒绝申请
    const handleReject = (user) => {
      ElMessageBox.confirm(`确定要拒绝 ${user.name} 的贫困生申请吗？`, "确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info",
      })
        .then(async () => {
          try {
            await userApi.rejectPoorApplication(user.id);
            ElMessage.success("已撤销申请");
            fetchApplications(); // 重新加载列表
          } catch (error) {
            console.error("撤销申请失败:", error);
            ElMessage.error("撤销申请失败");
          }
        })
        .catch(() => {
          ElMessage.info("已取消操作");
        });
    };

    // 初始化
    fetchApplications();

    const tableRowClassName = ({ rowIndex }) => {
      return rowIndex % 2 === 0 ? "even-row" : "odd-row";
    };

    return {
      applications,
      loading,
      downloadFile,
      handleApprove,
      tableRowClassName,
      handleReject,
    };
  },
};
</script>

<style scoped>
.poor-applications {
  padding: 20px;
  background-color: #f0f2f5;
  min-height: calc(100vh - 40px);
}

.box-card {
  border-radius: 8px;
  transition: all 0.3s;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
}

.title {
  margin: 0;
  font-size: 20px;
  color: #303133;
}

.action-button {
  padding: 4px 8px;
  transition: all 0.3s;
}

.action-button:hover {
  transform: translateY(-1px);
}

.action-button .el-icon {
  margin-right: 4px;
  vertical-align: middle;
}

.even-row {
  background-color: #ffffff;
}

.odd-row {
  background-color: #fafafa;
}

/* 添加表格hover效果 */
:deep(.el-table__row:hover) {
  background-color: #f5f7fa !important;
  transition: background-color 0.3s;
}

/* 美化滚动条 */
:deep(.el-table__body-wrapper::-webkit-scrollbar) {
  width: 6px;
  height: 6px;
}

:deep(.el-table__body-wrapper::-webkit-scrollbar-thumb) {
  background: #dcdfe6;
  border-radius: 3px;
}

:deep(.el-table__body-wrapper::-webkit-scrollbar-track) {
  background: #f5f7fa;
}
</style> 